<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div id="contents">
<div class="toc-frontmatter-group">
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-001-xhtml">
<p class="element-title"><a href="#/chapter001"><span class="element-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-002-xhtml">
<p class="element-title"><a href="#/chapter002"><span class="element-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-003-xhtml">
<p class="element-title"><a href="#/chapter003"><span class="element-title-text">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-004-xhtml">
<p class="element-title"><a href="#/chapter004"><span class="element-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-005-xhtml">
<p class="element-title"><a href="#/chapter005"><span class="element-title-text">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-006-xhtml">
<p class="element-title"><a href="#/chapter006"><span class="element-title-text">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-007-xhtml">
<p class="element-title"><a href="#/chapter007"><span class="element-title-text">Chapter 7</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-008-xhtml">
<p class="element-title"><a href="#/chapter008"><span class="element-title-text">Chapter 8</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-009-xhtml">
<p class="element-title"><a href="#/chapter009"><span class="element-title-text">Chapter 9</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-010-xhtml">
<p class="element-title"><a href="#/chapter010"><span class="element-title-text">Chapter 10</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-011-xhtml">
<p class="element-title"><a href="#/chapter011"><span class="element-title-text">Chapter 11</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-012-xhtml">
<p class="element-title"><a href="#/chapter012"><span class="element-title-text">Chapter 12</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-013-xhtml">
<p class="element-title"><a href="#/chapter013"><span class="element-title-text">Chapter 13</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-014-xhtml">
<p class="element-title"><a href="#/chapter014"><span class="element-title-text">Chapter 14</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-015-xhtml">
<p class="element-title"><a href="#/chapter015"><span class="element-title-text">Chapter 15</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-016-xhtml">
<p class="element-title"><a href="#/chapter016"><span class="element-title-text">Chapter 16</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-017-xhtml">
<p class="element-title"><a href="#/chapter017"><span class="element-title-text">Chapter 17</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-018-xhtml">
<p class="element-title"><a href="#/chapter018"><span class="element-title-text">Chapter 18</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-019-xhtml">
<p class="element-title"><a href="#/chapter019"><span class="element-title-text">Chapter 19</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-020-xhtml">
<p class="element-title"><a href="#/chapter020"><span class="element-title-text">Chapter 20</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-021-xhtml">
<p class="element-title"><a href="#/chapter021"><span class="element-title-text">Chapter 21</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-022-xhtml">
<p class="element-title"><a href="#/chapter022"><span class="element-title-text">Chapter 22</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-023-xhtml">
<p class="element-title"><a href="#/chapter023"><span class="element-title-text">Chapter 23</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-024-xhtml">
<p class="element-title"><a href="#/chapter024"><span class="element-title-text">Chapter 24</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-025-xhtml">
<p class="element-title"><a href="#/chapter025"><span class="element-title-text">Chapter 25</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-026-xhtml">
<p class="element-title"><a href="#/chapter026"><span class="element-title-text">Chapter 26</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-027-xhtml">
<p class="element-title"><a href="#/chapter027"><span class="element-title-text">Chapter 27</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-028-xhtml">
<p class="element-title"><a href="#/chapter028"><span class="element-title-text">Chapter 28</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-029-xhtml">
<p class="element-title"><a href="#/chapter029"><span class="element-title-text">Chapter 29</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-030-xhtml">
<p class="element-title"><a href="#/chapter030"><span class="element-title-text">Chapter 30</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-031-xhtml">
<p class="element-title"><a href="#/chapter031"><span class="element-title-text">Chapter 31</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-032-xhtml">
<p class="element-title"><a href="#/chapter032"><span class="element-title-text">Chapter 32</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-033-xhtml">
<p class="element-title"><a href="#/chapter033"><span class="element-title-text">Chapter 33</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-034-xhtml">
<p class="element-title"><a href="#/chapter034"><span class="element-title-text">Chapter 34</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-035-xhtml">
<p class="element-title"><a href="#/chapter035"><span class="element-title-text">Chapter 35</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-036-xhtml">
<p class="element-title"><a href="#/chapter036"><span class="element-title-text">Chapter 36</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-037-xhtml">
<p class="element-title"><a href="#/chapter037"><span class="element-title-text">Chapter 37</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-038-xhtml">
<p class="element-title"><a href="#/chapter038"><span class="element-title-text">Chapter 38</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-039-xhtml">
<p class="element-title"><a href="#/chapter039"><span class="element-title-text">Chapter 39</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-040-xhtml">
<p class="element-title"><a href="#/chapter040"><span class="element-title-text">Chapter 40</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-041-xhtml">
<p class="element-title"><a href="#/chapter041"><span class="element-title-text">Chapter 41</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-042-xhtml">
<p class="element-title"><a href="#/chapter042"><span class="element-title-text">Chapter 42</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-043-xhtml">
<p class="element-title"><a href="#/chapter043"><span class="element-title-text">Chapter 43</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-044-xhtml">
<p class="element-title"><a href="#/chapter044"><span class="element-title-text">Chapter 44</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-045-xhtml">
<p class="element-title"><a href="#/chapter045"><span class="element-title-text">Chapter 45</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-046-xhtml">
<p class="element-title"><a href="#/chapter046"><span class="element-title-text">Chapter 46</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-047-xhtml">
<p class="element-title"><a href="#/chapter047"><span class="element-title-text">Chapter 47</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-048-xhtml">
<p class="element-title"><a href="#/chapter048"><span class="element-title-text">Chapter 48</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-049-xhtml">
<p class="element-title"><a href="#/chapter049"><span class="element-title-text">Chapter 49</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-050-xhtml">
<p class="element-title"><a href="#/chapter050"><span class="element-title-text">Chapter 50</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-051-xhtml">
<p class="element-title"><a href="#/chapter051"><span class="element-title-text">Chapter 51</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-052-xhtml">
<p class="element-title"><a href="#/chapter052"><span class="element-title-text">Chapter 52</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-053-xhtml">
<p class="element-title"><a href="#/chapter053"><span class="element-title-text">Chapter 53</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number" id="a-note-from-bloodhound-books-xhtml">
<p class="element-title"><a href="#/anotefrombloodhoundbooks"><span class="element-title-text">A Note from Bloodhound Books:</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number" id="epilogue-xhtml">
<p class="element-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="element-title-text">Epilogue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number" id="acknowledgments-xhtml">
<p class="element-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="element-title-text">Acknowledgments</span></span></p>
</div>
</div>
</div>
<div class="footer"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// table-of-contents.vue?b9da617a